import * as React from "react";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import MyChartContainer from "./MyChartContainer";

const DownloadMyRecord = () => {
    logUI("MBHWeb.UI.DownloadMyRecord.ComponentDidMount", new Date(), Tools.getURLPath());
    const bswMatch = ".card";
    const events = [{ elements: ".formcontents .card", eventName: "click", message: "touched" }];
        
    return <MyChartContainer mode="documents" title="Download My Record"
        events={events}
        bswMatch={bswMatch} />;
};

export default DownloadMyRecord;